// Imports
import { StripeError } from '@stripe/stripe-js';
import commonActions from '../../../foundation/front-end/redux/actions';
import store from '../../../foundation/front-end/redux/store';
import modifyStripeMessage from './modify-stripe-message';
import reportStripeError from './report-stripe-error';


// Define the accepted options
interface Options {
	confirmedWithPaymentElement: boolean;
}


/** Delegates what Stripe errors should be shown to users, and what errors are unexpected (and should be reported to Sentry); error messages shown to users are modified to user friendly versions first */
export default function handleStripeConfirmationError(
	error: StripeError,
	{ confirmedWithPaymentElement }: Options
): void {
	// Errors that Stripe's Payment Element already renders inline
	const handledInlineByStripe =
		confirmedWithPaymentElement && (error.type === 'card_error' || error.type === 'validation_error');
	
	
	// Let Stripe handle inline field errors silently
	if (handledInlineByStripe) {
		return;
	}
	
	
	// Show modified message
	if (error.type === 'card_error' || error.code === 'bank_account_unusable') {
		store.dispatch(
			commonActions.showPageMessage({
				color: 'danger',
				title: 'Payment failed',
				message: modifyStripeMessage(
					error.message ??
						'Something went wrong while processing these details. Please double-check the details and try again.'
				),
			})
		);
		
		
		// Return
		return;
	}
	
	
	// Handle 3DS authentication failures
	if (error.code === 'payment_intent_authentication_failure' || error.code === 'setup_intent_authentication_failure') {
		store.dispatch(
			commonActions.showPageMessage({
				color: 'danger',
				title: 'Oh snap!',
				message:
					'Credit/debit card verification failed. Please try again, use a different payment method, or contact your card issuer for assistance completing their verification process.',
			})
		);
		
		
		// Return
		return;
	}
	
	
	// Handle all other unexpected errors
	reportStripeError(error);
	
	store.dispatch(
		commonActions.showPageMessage({
			color: 'danger',
			title: 'Oh snap!',
			message: 'There was an unexpected issue.',
		})
	);
}
